// Single source of truth for the Consultation/Procedure queue-modal tab list.
// Both ConsultationPatientQueueModal.vue and ProcedurePatientQueueModal.vue build
// their menuItems from these helpers instead of hand-maintaining separate arrays.

const TABS = {
  SUMMARY:              { title: "Summary",                      component: "EncounterSummaryTab" },
  PATIENT_DOCUMENTS:     { title: "Patient Documents",             component: "PatientDocumentsTab" },
  TRIAGE:                { title: "Triage Assessment",             component: "TriageAssessment" },
  PRESENTING_COMPLAINT:  { title: "Presenting Complaint",          component: "PresentingComplaint" },
  PHYSICAL_EXAM:         { title: "Physical Exam",                 component: "PhysicalExam" },
  REQUEST:               { title: "Lab / Rad / Procedure Request", component: "InvestigationProcedure" },
  LAB_RAD_RESULTS:       { title: "Lab / Rad Results",             component: "ProcedureResults" },
  EXTERNAL_LAB_RESULTS:  { title: "Upload Lab Results",            component: "ExternalLabResultsTab" },
  EXTERNAL_RAD_RESULTS:  { title: "Upload Radiology Results",      component: "ExternalRadiologyResultsTab" },
  DIAGNOSIS:             { title: "Diagnosis",                     component: "DiagnosisTab" },
  PRESCRIPTION:          { title: "Prescription",                  component: "PrescriptionTab" },
};

function withIds(items) {
  return items.map((item, index) => ({ id: index + 1, ...item }));
}

export function buildConsultationMenuItems({ showTriage }) {
  const items = [
    TABS.SUMMARY,
    TABS.PATIENT_DOCUMENTS,
    TABS.TRIAGE,
    TABS.PRESENTING_COMPLAINT,
    TABS.PHYSICAL_EXAM,
    TABS.REQUEST,
    TABS.LAB_RAD_RESULTS,
    TABS.EXTERNAL_LAB_RESULTS,
    TABS.EXTERNAL_RAD_RESULTS,
    TABS.DIAGNOSIS,
    TABS.PRESCRIPTION,
  ];
  return withIds(showTriage ? items : items.filter((i) => i.component !== "TriageAssessment"));
}

export function buildProcedureMenuItems() {
  return withIds([
    TABS.SUMMARY,
    TABS.PATIENT_DOCUMENTS,
    TABS.PRESENTING_COMPLAINT,
    TABS.PHYSICAL_EXAM,
    TABS.REQUEST,
    TABS.LAB_RAD_RESULTS,
    TABS.EXTERNAL_LAB_RESULTS,
    TABS.EXTERNAL_RAD_RESULTS,
    TABS.DIAGNOSIS,
    TABS.PRESCRIPTION,
  ]);
}
